import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ProductPreview from '../components/ProductPreview/ProductPreview';
import './WelcomePage.css';

function WelcomePage() {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);

  // Animate steps: complete one every 2.5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStep((prev) => (prev + 1) % 4);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  const handleStart = () => {
    navigate('/signup');
  };

  const handleLogin = () => {
    navigate('/login');
  };

  const steps = [
    {
      number: '1',
      title: 'Research possible colleges',
      description: 'Compare schools in focused dashboards',
    },
    {
      number: '2',
      title: 'Choose your final list',
      description: 'Keep active applications in Progress',
    },
    {
      number: '3',
      title: 'Add dates and next steps',
      description: 'See them in Home, Calendar, and reminders',
    },
    {
      number: '4',
      title: 'Track every application',
      description: 'Complete tasks and mark colleges submitted',
    },
  ];

  const renderStep = (index) => {
    const isCompleted = index < currentStep;
    const dotClass = isCompleted ? 'rd-done' : index === currentStep ? 'rd-active' : 'rd-pending';
    const dotContent = isCompleted ? '✓' : steps[index].number;
    const hasLine = index < steps.length - 1;

    return (
      <div key={index} className="rm-step">
        <div className="rm-dot-col">
          <div className={`rm-dot ${dotClass}`}>{dotContent}</div>
          {hasLine && <div className="rm-line"></div>}
        </div>
        <div className="rm-text">
          <strong>{steps[index].title}</strong>
          <span>{steps[index].description}</span>
        </div>
      </div>
    );
  };

  return (
    <div className="welcome-screen">
      <div className="w-inner">
        <div className="w-left">
          <div className="w-brand">MaiColleges</div>
          <h1 className="w-hero">
            Start your summer college search <span>with one organized dashboard.</span>
          </h1>
          <p className="w-sub">
            Built for juniors beginning research before senior year. Compare schools,
            save notes, and turn a messy list into a dashboard you can actually use.
          </p>
          <div className="w-trust-list" aria-label="Why students can trust MaiColleges">
            <span>College facts use U.S. Department of Education College Scorecard data.</span>
            <span>Built for students managing real applications, essays, deadlines, and tasks.</span>
          </div>
          <div className="w-actions">
            <button className="btn btn-dark btn-lg" onClick={handleStart}>
              Build a Dashboard →
            </button>
            <button className="btn btn-ghost btn-lg" onClick={handleLogin}>
              Sign In
            </button>
          </div>
          <p className="w-trust">Your planning data syncs to your signed-in account and is cached on this device for faster loading.</p>
        </div>

        <div className="w-right">
          <ProductPreview />

          <div className="roadmap-card">
            <div className="rm-label">What you'll go through</div>

            {steps.map((_, index) => renderStep(index))}

            <div className="word-cloud">
              <span className="wchip">Essays</span>
              <span className="wchip">FAFSA</span>
              <span className="wchip">Recs</span>
              <span className="wchip">Deadlines</span>
              <span className="wchip">Common App</span>
              <span className="wchip">Supplements</span>
            </div>
          </div>
        </div>

        <footer className="site-footer welcome-footer">
          <span>© 2026 MaiColleges</span>
          <div>
            <a href="/about">About Us</a>
            <a href="/support">Support</a>
            <a href="/contact">Contact Us</a>
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSeeM81wlBlaGlwaO5zZCo-3X0wP0wKe5kMuGodEffWcIXSx1w/viewform?usp=publish-editor" target="_blank" rel="noreferrer">Bug &amp; Feature Form</a>
            <a href="/privacy">Privacy</a>
            <a href="/terms">Terms</a>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default WelcomePage;
